var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.603,
    height: 36.602,
    viewBox: "0 0 38.603 36.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School",
    transform: "translate(-2.997 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M40.933,41.271h-2V25.965h2a.665.665,0,0,0,.619-.915l-3.993-9.98a.666.666,0,0,0-.619-.42H24.962a.466.466,0,0,0-.093,0l-1.9-1.716v-1.61h5.988a.666.666,0,0,0,.666-.666V6.666A.666.666,0,0,0,28.953,6H22.3a.666.666,0,0,0-.666.666v6.269l-1.9,1.716a.466.466,0,0,0-.093,0H7.658a.666.666,0,0,0-.619.42L3.046,25.052a.665.665,0,0,0,.619.915h2v15.3h-2a.666.666,0,0,0,0,1.331H40.933a.666.666,0,1,0,0-1.331ZM36.488,15.982l3.458,8.652H29.617V19.309a.945.945,0,0,0,0-.146.5.5,0,0,0,0-.106.985.985,0,0,0-.054-.087,1.037,1.037,0,0,0-.093-.127h0l-3.181-2.86ZM22.964,7.331h5.324V9.993H22.964ZM8.111,15.982H18.306l-3.1,2.836h0a.786.786,0,0,0-.087.114.732.732,0,0,0-.059.093.439.439,0,0,0,0,.1,1.258,1.258,0,0,0-.08.18v5.324H4.65ZM6.992,25.965h7.986V41.271H6.992ZM19.637,41.271V31.954h5.324v9.316Zm6.655,0V31.289a.666.666,0,0,0-.666-.666H18.971a.666.666,0,0,0-.666.666v9.982h-2V19.6L22.3,14.121,28.288,19.6V41.271Zm3.327,0V25.965h7.986V41.271Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M15.327,44H12.666a.666.666,0,0,0-.666.666v2.662a.666.666,0,0,0,.666.666h2.662a.666.666,0,0,0,.666-.666V44.666A.666.666,0,0,0,15.327,44Zm-.666,2.662h-1.33v-1.33h1.331Z",
    transform: "translate(-3.011 -12.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M49.327,44H46.666a.666.666,0,0,0-.666.666v2.662a.666.666,0,0,0,.666.666h2.662a.666.666,0,0,0,.666-.666V44.666A.666.666,0,0,0,49.327,44Zm-.666,2.662h-1.33v-1.33h1.331Z",
    transform: "translate(-14.384 -12.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M30.662,28a2.662,2.662,0,1,0,2.662,2.662A2.662,2.662,0,0,0,30.662,28Zm0,3.993a1.331,1.331,0,1,1,1.331-1.331,1.331,1.331,0,0,1-1.331,1.331Z",
    transform: "translate(-8.363 -7.359)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.00b45d42405ddb67464659138075788d.svg";
export { ForwardRef as ReactComponent };